import Screen from '../../../shared/components/screen';
import {Props} from './model';
import * as React from 'react';
import {View} from 'react-native';
import {PollVoteResult} from '../components/pollVoteResult';
import {useStyles} from '../../../shared/hooks/styles';
import {CustomScrollView} from '../../../shared/components/scrollView';

export default ({poll, isVoteCompleteNow = false}: Props) => {
  const styles = useStyles(({theme}) => ({
    sectionContainer: {
      paddingVertical: 30,
      paddingHorizontal: 24,
      paddingBottom: theme.screen.bottomOffset,
    },
  }));
  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          {poll ? <PollVoteResult isVoteCompleteNow={isVoteCompleteNow} poll={poll} /> : null}
        </View>
      </CustomScrollView>
    </Screen>
  );
};
